import { Box, Button, styled, Typography } from '@mui/material';
import useGoTo from 'src/hooks/useGoTo';

import OpenedBook from 'src/icons/OpenedBook';

interface IEmptyProps {
    icon?: React.ReactNode;
    title?: string;
    text?: string;
    withMainButton?: boolean;
}

const Wrapper = styled(Box)`
    & > div:first-of-type {
        width: 80px;
        height: 80px;
        & svg {
            width: 100%;
            height: 100%;
        }
    }
`;

export default function Empty({
    icon = <OpenedBook />,
    title,
    text = 'Ничего не найдено',
    withMainButton = true,
}: IEmptyProps) {
    const goTo = useGoTo();

    const onMainButtonClick = () => {
        goTo('/');
    };

    return (
        <Wrapper
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            flexGrow={20}
            minHeight={200}
            gap={title ? 1 : 2}
        >
            <Box>{icon}</Box>
            {title && (
                <Box>
                    <Typography
                        variant="body1"
                        color="text.primary"
                        textAlign="center"
                        fontWeight="500"
                    >
                        {title}
                    </Typography>
                </Box>
            )}

            <Box>
                <Typography
                    variant={title ? 'body2' : 'h2'}
                    color="secondary"
                    textAlign="center"
                    sx={{ whiteSpace: 'pre-line', lineHeight: '10px' }}
                >
                    {text}
                </Typography>
            </Box>
            {withMainButton && (
                <Button
                    onClick={onMainButtonClick}
                    variant="contained"
                    fullWidth={false}
                    size="large"
                >
                    На главную
                </Button>
            )}
        </Wrapper>
    );
}
